angular.module('controllers').controller('apiController', ['$scope', '$rootScope', '$controller', '$http', 'Crud', '$mdDialog',
    function ($scope, $rootScope, $controller, $http, Crud, $mdDialog) {
        $rootScope.path = '/api';
        $rootScope.modelName = 'api';
        $scope.path = $rootScope.path;
        $scope.pathTemplate = 'app/api';
        $scope.title = 'ApiInfo';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $rootScope.sortType = 'id';
        $rootScope.typeId = 'id';
        $scope.additionals = [];
        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.message = '';
        $scope.classAction = 'td-big';

        $scope.getIndex = function () {
            $scope.additionals['invalid'] = '';
            Crud.get($scope.path+'/index')
                .success(function (data) {
                   $scope.html = data;
                });
        }

        $scope.getIndex();

    }]
)